import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import {
  GET_ASSIGN_DRIVER,
  BOOKING_GUEST_ASSIGN_DRIVER,
} from "../../../services/ApiCalls";
import { toast } from "react-toastify";
import CustomPagination from "../../../components/Common/CustomPagination";
import Table from "../../../components/Common/Table";

import PaginationFilter from "../../../components/Common/PaginationFilter";
import Search from "../../../components/Common/Search";

const GuestAssignDriver = ({ bookid, setShowModal, getBookingDetails, handleClose }) => {
  const [drivers, setDrivers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [assignedDrivers, setAssignedDrivers] = useState([]);
  const [body, setBody] = useState({
    page: 1,
    limit: 10,
    orderBy: 1,
    order: -1,
    search: "",
    status: "all",
  });

  const [assignbody, setAssignBody] = useState({
    bookingId: bookid,
    driverId: "",
  });

  const getDrivers = async (body, index = -1) => {
    setLoader(true);
    try {
      const res = await GET_ASSIGN_DRIVER(body);

      if (res?.data?.status === "success") {
        const driversData = res?.data?.data || [];
        const filteredDrivers = driversData.filter(
          (driver) => !assignedDrivers.includes(driver._id)
        );
        setDrivers(filteredDrivers);
        setTotalCount(filteredDrivers.length);

        if (
          filteredDrivers.length > 0 &&
          index >= 0 &&
          index < filteredDrivers.length
        ) {
          const driverId = filteredDrivers[index]?._id || "";
          setAssignBody((prevState) => ({
            ...prevState,
            driverId,
          }));
        } else {
          setAssignBody((prevState) => ({
            ...prevState,
            driverId: "",
          }));
        }

        setLoader(false);
      } else {
        toast.error(res?.data?.message);
        setLoader(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setLoader(false);
      // toast.error("Something went wrong");
    }
  };

  useEffect(() => {
    getDrivers(body);
  }, [body.search, body.limit, body.status]);

  const pageChangeHandler = (page) => {
    setBody((prevBody) => ({
      ...prevBody,
      page,
    }));
    getDrivers({ ...body, page });
  };

  const searchHandler = () => {
    setBody((prevBody) => ({
      ...prevBody,
      page: 1,
    }));
    getDrivers({ ...body, page: 1 });
  };

  const col = [
    {
      label: "Sr no",
      id: "srNo",
      isComponent: true,
      component: (_, key) => (
        <p className="m-0">{(body.page - 1) * body.limit + (key + 1)}</p>
      ),
    },
    {
      label: "Driver Name",
      id: "name",
      classNames: "fw-sbold themeBlue",
    },
    {
      label: "Action",
      isComponent: true,
      component: (item, index) => (
        <div className="actnBtn d-flex align-items-start justify-content-start gap-10">
          <Button
            className="border-0 commonBtn w-50 GreyBtnAssign"
            variant="transparent"
            type="button"
            style={{ height: "30px" }}
            onClick={() => {
              assignDriver(item, index);
            }}
          >
            Assign
          </Button>
        </div>
      ),
    },
  ];

  const assignDriver = async (item, index) => {
    try {
      if (index >= 0 && index < drivers.length) {
        const driverId = drivers[index]?._id || "";
        setAssignBody((prevState) => ({
          ...prevState,
          driverId: driverId,
          bookingId: bookid,
        }));

        const res = await BOOKING_GUEST_ASSIGN_DRIVER({
          ...assignbody,
          driverId,
        });

        if (res?.data?.status === "success") {
          toast.success(res?.data?.message);

          // Update the assigned drivers list
          setAssignedDrivers((prevState) => [...prevState, driverId]);

          // Remove the assigned driver from the available list
          setDrivers((prevDrivers) =>
            prevDrivers.filter((driver) => driver._id !== driverId)
          );
          setTotalCount(totalCount - 1);
          setShowModal(false);
          handleClose()
          getBookingDetails()
        } else {
          toast.error(res?.data?.message);
        }
      } else {
        // toast.error("Invalid driver index");
        console.log("Invalid driver index");
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      // toast.error("Something went wrong");
    }
  };

  return (
    <section className="manageDriver py-2 position-relative">
      <Container>
        <Row>
          <Col lg="12" className="my-2">
            <div className="tableFilter d-flex align-items-center justify-content-between gap-10 mb-3 mt-3">
              <div className="left">
                <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                  {/* <StatusFilter
                    body={body}
                    setBody={setBody}
                    statusFilterOptionArr={statusFilterOptionArr}
                  /> */}
                  <PaginationFilter body={body} setBody={setBody} />
                  <Search searchHandler={searchHandler} setBody={setBody} />
                </ul>
              </div>
            </div>
            <div className="table-responsive">
              <Table data={drivers} loader={loader} column={col} />

              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <div className="left">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                    <li>
                      <p className="m-0 fw-sbold">
                        Total drivers: {totalCount}
                      </p>
                    </li>
                  </ul>
                </div>
                <div className="right">
                  <CustomPagination
                    total={totalCount}
                    current={body.page}
                    pageSize={body.limit}
                    pageChangeHandler={pageChangeHandler}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default GuestAssignDriver;
